// Static country metadata mirror for instant rendering. Backend remains source of truth.
export const COUNTRIES = [
  {
    slug: "vietnam",
    name: "Vietnam",
    tagline: "Limestone bays & street-food capitals",
    image:
      "https://images.unsplash.com/photo-1754726705006-97994f04d139?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "e-Visa · 90 days",
    span: "wide",
  },
  {
    slug: "thailand",
    name: "Thailand",
    tagline: "Temples, islands, night markets",
    image:
      "https://images.unsplash.com/photo-1582468546235-9bf31e5bc4a1?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Visa-free · 60 days",
    span: "tall",
  },
  {
    slug: "bali",
    name: "Bali",
    tagline: "Rice terraces & sunset surf",
    image:
      "https://images.unsplash.com/photo-1729605411937-4cb475d6aa51?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "VoA · 30 days",
    span: "normal",
  },
  {
    slug: "japan",
    name: "Japan",
    tagline: "Neon nights, cherry-blossom days",
    image:
      "https://images.unsplash.com/photo-1509023464722-18d996393ca8?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Sticker visa",
    span: "wide",
  },
  {
    slug: "maldives",
    name: "Maldives",
    tagline: "Overwater villas & glass lagoons",
    image:
      "https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Free · 90 days",
    span: "normal",
  },
  {
    slug: "oman",
    name: "Oman",
    tagline: "Wadi pools & frankincense souqs",
    image:
      "https://images.unsplash.com/photo-1567948060823-d32f40b60186?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "e-Visa · 30 days",
    span: "tall",
  },
  {
    slug: "malaysia",
    name: "Malaysia",
    tagline: "Skyline highs, rainforest hides",
    image:
      "https://images.unsplash.com/photo-1508062878650-88b52897f298?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Visa-free · 30 days",
    span: "normal",
  },
  {
    slug: "singapore",
    name: "Singapore",
    tagline: "Gardens, hawker stalls, sky bars",
    image:
      "https://images.unsplash.com/photo-1544214036-5aaeb9e32d11?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "e-Visa · 30 days",
    span: "wide",
  },
  {
    slug: "sri-lanka",
    name: "Sri Lanka",
    tagline: "Tea trails & wild coastlines",
    image:
      "https://images.unsplash.com/photo-1566296314736-6eaac1ca0cb9?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "ETA · 30 days",
    span: "normal",
  },
  {
    slug: "nepal",
    name: "Nepal",
    tagline: "Himalayan heights & old-town heart",
    image:
      "https://images.unsplash.com/photo-1518002054494-3a6f94352e9d?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Visa-free",
    span: "tall",
  },
  {
    slug: "philippines",
    name: "Philippines",
    tagline: "7,000 turquoise islands",
    image:
      "https://images.unsplash.com/photo-1758782551976-bde9ad21b967?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Conditional · 14 days",
    span: "wide",
  },
  {
    slug: "laos",
    name: "Laos",
    tagline: "Saffron monks & jungle waterfalls",
    image:
      "https://images.unsplash.com/photo-1554629713-42a71f7ec2b3?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "VoA · 30 days",
    span: "normal",
  },
  {
    slug: "china",
    name: "China",
    tagline: "Great Wall, silk-road cities & neon megacities",
    image:
      "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?crop=entropy&cs=srgb&fm=jpg&q=85",
    visa: "Sticker · 30 days",
    span: "wide",
  },
];

export const COUNTRY_BY_SLUG = Object.fromEntries(
  COUNTRIES.map((c) => [c.slug, c]),
);

export const CITIES_BY_COUNTRY = {
  vietnam: ["Hanoi", "Ha Long Bay", "Sapa", "Hoi An", "Da Nang", "Ho Chi Minh City", "Phu Quoc", "Ninh Binh"],
  thailand: ["Bangkok", "Chiang Mai", "Phuket", "Krabi", "Koh Samui", "Pattaya", "Ayutthaya", "Koh Phi Phi"],
  bali: ["Ubud", "Seminyak", "Canggu", "Uluwatu", "Nusa Penida", "Kuta", "Sanur", "Gili Islands"],
  japan: ["Tokyo", "Kyoto", "Osaka", "Mount Fuji / Hakone", "Nara", "Hiroshima", "Sapporo", "Okinawa"],
  maldives: ["Male", "Maafushi", "Hulhumale", "North Male Atoll", "South Ari Atoll", "Baa Atoll"],
  oman: ["Muscat", "Nizwa", "Wahiba Sands", "Salalah", "Jebel Akhdar", "Sur", "Musandam"],
  malaysia: ["Kuala Lumpur", "Langkawi", "Penang", "Cameron Highlands", "Malacca", "Kota Kinabalu", "Borneo"],
  singapore: ["Marina Bay", "Sentosa", "Chinatown", "Little India", "Orchard", "Gardens by the Bay"],
  "sri-lanka": ["Colombo", "Kandy", "Ella", "Nuwara Eliya", "Galle", "Sigiriya", "Mirissa", "Yala"],
  nepal: ["Kathmandu", "Pokhara", "Chitwan", "Nagarkot", "Lumbini", "Everest Base Camp", "Annapurna"],
  philippines: ["Manila", "Palawan / El Nido", "Coron", "Cebu", "Bohol", "Siargao", "Boracay"],
  laos: ["Luang Prabang", "Vientiane", "Vang Vieng", "4000 Islands", "Plain of Jars"],
  china: ["Beijing", "Shanghai", "Xi'an", "Chengdu", "Guangzhou", "Guilin", "Hong Kong", "Hangzhou"],
};

